// extracted by mini-css-extract-plugin
export var buttonsWrapper = "SliderControl-module--buttonsWrapper--74bc2";
export var text = "SliderControl-module--text--ac069";
export var white = "SliderControl-module--white--3a528";
export var nextButton = "SliderControl-module--nextButton--632f5";